import React from 'react'
import { Row, Col, ControlLabel, Alert } from 'react-bootstrap'

import DataDropdown from 'syft-acp-core/components/EditableTable/DataDropdown'
import EditableTextbox from 'syft-acp-core/components/EditableTextbox'

import { endJobAssignmentReasons } from '../EndJobAssignmentModal/structure'
import { ShiftRow } from './ShiftRow'
import { isOtherReason } from './helpers'
import { CancelReason, WorkerJobBooking } from './types'

// Step 1's body: pick which shifts to cancel and why. Extracted purely to keep the
// container's render complexity down — all state lives in the parent.
export const ShiftSelectStep = ({
  worker,
  isBlockBooking,
  bookings,
  allSelected,
  toggleAll,
  selected,
  toggleShift,
  selectedHasFlag,
  reason,
  reasonLabel,
  setReason,
  otherReason,
  setOtherReason,
}: {
  worker: { first_name?: string; last_name?: string }
  isBlockBooking: boolean
  bookings: WorkerJobBooking[]
  allSelected: boolean
  toggleAll: () => void
  selected: number[]
  toggleShift: (id: number) => void
  selectedHasFlag: boolean
  reason: CancelReason
  reasonLabel: string | null | undefined
  setReason: (value: string) => void
  otherReason: string | undefined
  setOtherReason: (value?: string) => void
}) => (
  <>
    {isBlockBooking && (
      <Row>
        <Col md={12}>
          <Alert bsStyle="info">
            <strong>Block booking:</strong> only the shifts selected below will be cancelled. To remove this
            worker from every upcoming shift shown, tick <strong>Select all shifts</strong>.
          </Alert>
        </Col>
      </Row>
    )}
    <Row>
      <Col md={12}>
        <ControlLabel>
          {worker.first_name} {worker.last_name} is booked on {bookings.length} upcoming{' '}
          {bookings.length === 1 ? 'shift' : 'shifts'}. Select which to cancel:
        </ControlLabel>
      </Col>
    </Row>
    <Row>
      <Col md={12}>
        <label style={{ fontWeight: 600 }}>
          <input type="checkbox" checked={allSelected} onChange={toggleAll} /> Select all shifts
        </label>
      </Col>
    </Row>
    <Row>
      <Col md={12}>
        {bookings.map(b => (
          <ShiftRow
            key={b.shift_id}
            booking={b}
            checked={selected.includes(b.shift_id)}
            onToggle={toggleShift}
          />
        ))}
      </Col>
    </Row>

    {selectedHasFlag && (
      <Row>
        <Col md={12}>
          <Alert bsStyle="warning">
            <strong>Heads up:</strong> a selected shift has <strong>FC</strong> (Flex Compensation) or{' '}
            <strong>CH</strong> (Compensation Hours) set. Cancelling removes the worker and this is your last
            chance to configure those flags — this cannot be undone.
          </Alert>
        </Col>
      </Row>
    )}

    <Row>
      <Col md={12}>
        <DataDropdown
          name="reasons"
          onChange={(value: string) => setReason(value)}
          value={reason}
          editable
          options={endJobAssignmentReasons}
          showDisabled
        />
      </Col>
    </Row>
    {isOtherReason(reasonLabel ?? reason) && (
      <Row>
        <Col md={12}>
          <EditableTextbox
            value={otherReason}
            placeholder="Please enter reason here"
            hasControls={false}
            onSave={(value?: string) => setOtherReason(value)}
          />
        </Col>
      </Row>
    )}
  </>
)
